module.exports = __webpack_public_path__ + "static/images/challenge.b297d9c87445a098b3d1b66e62b5a417.jpg";